// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Tjnw9","col":"styles_col__wAkeh"};